<template>
  <div class="layout-footer">
    <span class="footer-text" style="margin-right: 5px">iContae - Contabilidad en la nube</span>
    
  </div>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped></style>
